import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Modal,
  TextField,
  Tabs,
  Tab,
  useTheme,
  Pagination,
  PaginationItem,
  InputAdornment,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { PlayArrow, MoreVert, ArrowBack, GridView, TableView } from '@mui/icons-material';
import live from 'packages/novous_web/src/assets/icons/Live.svg';
import call from 'packages/novous_web/src/assets/icons/phone-calling.svg';
import clone from 'packages/novous_web/src/assets/icons/Clone.svg';
import reverse from 'packages/novous_web/src/assets/icons/Fast Backward.svg';
import map from 'packages/novous_web/src/assets/icons/Map Stroke.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
import add from 'packages/novous_web/src/assets/icons/add.svg';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import comment from 'packages/novous_web/src/assets/icons/Comment.svg';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import AlertToast from '../../../../common/components/Alert';
import LiveFeedModal from '../../Reports/components/LiveFeed';
import axiosInstance from '../../../../api/apiClient';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import calendar from 'packages/novous_web/src/assets/icons/calendar.svg';
import arrow from 'packages/novous_web/src/assets/icons/Arrow.svg';
import { getWarningIcon } from '../../Alarm/Vehicle-Alerts/helper/warningIcons';
import {
  MaterialReactTable,
  MRT_Cell,
  MRT_ColumnDef,
  MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import InputField from 'packages/novous_web/src/common/components/InputField';
import link from 'packages/novous_web/src/assets/icons/Link.svg';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import infoIcon from '../../../../assets/icons/i.svg';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';

interface Alert {
  id: string;
  driverName: string;
  vehicleNumber: string;
  device_id: string;
  vehicleId: string;
  date_time: string;
  vehicleName: string;
  warningSortKey: string;
  videoUrls: string[];
  warningType: string;
  driverId: string;
}
interface WarningData {
  warningName: string;
  alerts: Alert[];
}
interface AlertsGridProps {
  alerts?: Alert[];
  calledFromDriverAlerts?: boolean;
}

const dateTimeStyles = {
  fontFamily: '"Inter Tight", sans-serif',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0%',
  color: '#767676',
};
type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

const TripAllAlerts = () => {
  const heading = 'Share Footage';
  const subheading = 'Enter an email address to share this Footage';
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const warningName = params.get('warningName');
  const isCritical = params.get('isCritical') === 'true';
  console.log('isCritical', isCritical);
  const oldViewMode = params.get('viewMode');
  const oldStartDate = params.get('startDate');
  const oldEndDate = params.get('endDate');
  const oldSelectedDuration = params.get('selectedDuration');
  const calledFromDriverAlerts = location?.state?.calledFromDriverAlerts || false;
  const driverId = location?.state?.driverId || '';
  console.log('state', location.state);
  const tripDetails = location?.state?.tripDetails || {};
  const { user } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState<Alert[]>([]);
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const theme = useTheme();
  const navigate = useNavigate();
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({ isOpen: false, tripId: '', vehicleId: '' });
  const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [email, setEmail] = useState('');
  const [userEmailValid, setUserEmailValid] = useState(false);
  const [viewMode, setViewMode] = useState<any>(oldViewMode);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [startDate, setStartDate] = useState(oldStartDate || '');
  const [endDate, setEndDate] = useState(oldEndDate || '');
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const dateRangeArr = ['Today', 'Yesterday', '7 Days', '15 Days', '30 Days', 'Custom Range'];
  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    date_time: { name: 'Date and Time', status: true },
    vehicleId: { name: 'Vehicle Reg No', status: true },
    actions: { name: 'Actions', status: true },
  });
  console.log(oldStartDate, 'oldStartDate', oldEndDate, 'oldEndDate');

  const handleFilterClose = () => setIsFilterModelOpen(false);
  const [selectedDuration, setSelectedDuration] = useState(oldSelectedDuration || dateRangeArr[0]);
  const [liveFeedCameraInfo, setLiveFeedCameraInfo] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { data, error, loading, fetchData } = useAxios<any>(
    API_ENDPOINTS.alarm.VEHICLE_ALERT_COMMENT,
    'POST',
  );
  const { data: alertsData, fetchData: fetchAlertsData } = useAxios<any>(
    API_ENDPOINTS.alarm.VEHICLE_ALL_ALERTS_BY_WARNING,
    'POST',
  );
  const { data: alertsEmailData, fetchData: fetchAlertsEmailData } = useAxios<any>(
    `${API_ENDPOINTS.alarm.VEHICLE_ALERT_EMAIL}`,
    'POST',
  );
  const [selected, setSelected] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);
  const paginatedArr = useRef<any[]>([null]);
  const totalPages = paginatedArr.current.length;
  const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    if (page !== 1) {
      fetchAlertsData({
        fleetId: user?.customer_id,
        lastEvaluatedKey: paginatedArr.current[page - 1],
        warningType: warningName,
        startDate: startDate,
        endDate: endDate,
        vehicleId: tripDetails.vehicleId,
        ...(calledFromDriverAlerts && { driverId: driverId }),
      });
    } else {
      fetchAlertsData({
        fleetId: user?.customer_id,
        lastEvaluatedKey: null,
        warningType: warningName,
        startDate: startDate,
        endDate: endDate,
        vehicleId: tripDetails.vehicleId,
        ...(calledFromDriverAlerts && { driverId: driverId }),
      });
    }
    setCurrentPage(page);
  };
  const handleLiveFeedClose = () => {
    setIsLiveFeedOpen({ isOpen: false, tripId: '', vehicleId: '' });
    setSelected(2);
  };
  useEffect(() => {
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }, [selectedDuration]);

  const combineDateTime = (dateStr: string, timeStr: string): string => {
    const [hours, minutes, seconds = '00'] = timeStr.split(':');
    return `${dateStr}:${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    console.log('ignitionBasedStartTime', tripDetails);
    const ignitionBasedStartTime = combineDateTime(tripDetails.departureDate, tripDetails.departureTime);
    setStartDate(ignitionBasedStartTime);

    const ignitionBasedEndTime = combineDateTime(tripDetails.arrivalDate, tripDetails.arrivalTime);
    console.log('ignitionBasedEndTime', tripDetails.arrivalDate, tripDetails.arrivalTime);
    setEndDate(ignitionBasedEndTime);
    if (startDate && endDate) {
      fetchAlertsData({
        fleetId: user?.customer_id,
        startDate: startDate,
        endDate: endDate,
        warningType: warningName,
        lastEvaluatedKey: null,
        vehicleId: tripDetails.vehicleId,
        ...(viewMode === 'grid' && { pageSize: 300 }),
        ...(calledFromDriverAlerts && { driverId: driverId }),
      });
    }
  }, [startDate, endDate, selectedDuration, viewMode]);

  useEffect(() => {
    console.log('alertsData', alertsData);
    if (alertsData) {
      setAlerts(alertsData);
      setTotalRecords(alertsData.length || 0);
    } else {
      setAlerts([]);
    }
    if (alertsData?.data?.lastEvaluatedKey) {
      if (paginatedArr.current.length === currentPage) {
        paginatedArr.current.push(alertsData.data.lastEvaluatedKey);
      }
    }
  }, [alertsData]);
  const getDateRange = (range: string) => {
    const today = dayjs();
    let startDate, endDate;

    switch (range) {
      case 'Today':
        startDate = today.format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case 'Yesterday':
        startDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        endDate = startDate;
        break;
      case '7 Days':
        startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '15 Days':
        startDate = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '30 Days':
        startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      default:
        startDate = '';
        endDate = '';
    }
    return { startDate, endDate };
  };

  const handleOpenLiveFeed = (vehicleId: string, videoUrls: string[]) => {
    setIsLiveFeedOpen({ isOpen: true, tripId: vehicleId, vehicleId: vehicleId });
    const cameraInfo = videoUrls.map((url) => {
      const fileName = url.split('/').pop()?.split('?')[0] || '';
      const segments = fileName.split('_');
      const cameraCode = segments[1] || 'Unknown';
      const cameraMapping: Record<string, string> = {
        '01': 'FCW',
        '02': 'DSM',
        '03': 'REAR_CAMERA',
        '04': 'IN_CABIN',
      };
      const cameraId = cameraMapping[cameraCode] || 'Unknown';
      return { cameraId, cameraName: cameraId, playBackUrl: url };
    });
    setLiveFeedCameraInfo(cameraInfo);
    setSelected(0);
  };
  const viewMenuData = [
    {
      name: 'View Details',
      icon: eye,
      click: () => navigate('/alarm/vehicle-alert-details', { state: alert }),
    },
    {
      name: 'Driver History',
      icon: call,
      click: () => {
        redirectToDriverHistory();
      },
    },
    { name: 'Trip Reconstruction', icon: reverse, click: () => {} },
    { name: 'Share Alert', icon: share, click: () => setOpenEmailModal(true) },
  ];
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [alert, setSelectedAlert] = useState<Alert | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };
  const [alertComment, setAlertComment] = useState<string>('');
  const [driverDialogOpen, setDriverDialogOpen] = useState<any>();
  const redirectToDriverHistory = () => {
    if (!alert?.driverId || alert?.driverId === 'NA') {
      setDriverDialogOpen(true);
      return;
    } else {
      navigate(`/directories/drivers/${alert?.driverId}`);
    }
  };
  const driverDialogClose = () => {
    setDriverDialogOpen(false);
  };
  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, alert: any) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedAlert(alert);
  };
  const handleClose = () => {
    setModalOpen(false);
  };
  const handleCommentModalOpen = (alert: any) => {
    setSelectedAlert(alert);
    console.log('alert', alert);
    if (alert?.comment) {
      setAlertComment(alert?.comment);
    }
    setModalOpen(true);
  };
  const formatTimestamp = (timestamp: string) => {
    const [year, month, day, hour, minute, second] = timestamp?.split('_');
    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    return date
      .toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      .replace(',', '');
  };
  const saveComment = () => {
    fetchData({
      deviceId: alert?.device_id,
      comment: alertComment,
      sortKey: alert?.warningSortKey,
    });
    setModalOpen(false);
  };
  useEffect(() => {
    if (data?.status === 200) {
      setAlertMessage('Comment added successfully');
      setAlertType('success');
      setAlertOpen(true);
    }
  }, [data]);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setCalendarAnchorEl(event.currentTarget);
  };

  const handleCalendarMenuClose = (value?: string) => {
    console.log('Selected Value:', value);

    if (value) {
      setSelectedDuration(value);
      setShowDatePicker(value === 'Custom Range');
      const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
      setStartDate(newStartDate);
      setEndDate(newEndDate);
    }

    setAnchorEl(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleEmailClose = () => {
    setEmail('');
    setOpenEmailModal(false);
  };
  // Add this grouping function above your return statement
  const groupAlertsByDate = (alerts: Alert[]): Record<string, Alert[]> => {
    return alerts.reduce((acc: Record<string, Alert[]>, alert) => {
      const dateStr = alert.date_time.split('_').slice(0, 3).join('-');
      const date = new Date(dateStr.replace(/_/g, '-'));
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(alert);
      return acc;
    }, {});
  };

  const groupedAlerts = groupAlertsByDate(filteredData);
  useEffect(() => {
    const processData = (data: any[]) => {
      // Sort the data first
      const sorted = [...data].sort((a, b) => {
        const dateA = new Date(
          a.date_time.replace(/_/g, '-').replace(/(\d+)_(\d+)_(\d+)_(\d+)_(\d+)_(\d+)/, '$1-$2-$3T$4:$5:$6'),
        );
        const dateB = new Date(
          b.date_time.replace(/_/g, '-').replace(/(\d+)_(\d+)_(\d+)_(\d+)_(\d+)_(\d+)/, '$1-$2-$3T$4:$5:$6'),
        );
        return dateB.getTime() - dateA.getTime(); // Newest first
      });

      return sorted;
    };
    console.log('seacrchQuery', searchQuery);
    if (debouncedSearchQuery) {
      const filteredDataArr = alerts.filter(
        (alert: any) =>
          alert?.vehicleNumber?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          alert?.device_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          alert?.vehicleId?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setFilteredData(processData(filteredDataArr));
    } else {
      setFilteredData(processData(alerts));
    }
  }, [debouncedSearchQuery, alerts]);

  const columns: MRT_ColumnDef<Alert>[] = useMemo(
    () => [
      {
        accessorKey: 'date_time',
        header: 'Date and Time',
        Cell: ({ cell }: { cell: MRT_Cell<Alert> }) => {
          const value = cell.getValue<string>() || ''; // Fallback to an empty string
          console.log('value', cell.getValue<string>() || '');
          return (
            <Typography variant="body2" style={{ fontWeight: 400 }}>
              {formatTimestamp(value)}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'vehicleId',
        header: 'Vehicle Reg No',
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            color="tableSecondary"
            style={{ fontWeight: 400 }}
            className="px-2 py-1 bg-[#EAEEF4] rounded-md w-fit"
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        Cell: ({ row }) => (
          <>
            <IconButton
              sx={{ padding: 0 }}
              onClick={() => navigate('/alarm/vehicle-alert-details', { state: row.original })}
            >
              <img src={eye} alt="custom action" className="w-6 h-6" />
            </IconButton>
            <IconButton size="small" onClick={(event) => handleOpenMenu(event, row.original)} sx={{ p: 0 }}>
              <MoreVert fontSize="small" />
            </IconButton>
          </>
        ),
      },
    ],
    [],
  );
  const alertColumns: MRT_ColumnDef<Alert>[] = useMemo(() => {
    return columns.filter((column) => {
      const key = column.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [columns, columnObj]);
  const tableOptions: MRT_TableOptions<Alert> = {
    columns: alertColumns,
    data: filteredData,
    enableColumnActions: false,
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
        maxHeight: '300px',
        overflowY: 'auto',
      },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: theme.palette.mode === 'dark' ? '#000' : '#F0EFF8', // Black in dark mode, light color in light mode
        color: theme.palette.mode === 'dark' ? '#fff' : '#000', // White text in dark mode, black in light mode
        fontWeight: 'bold',
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor:
          row.index % 2 === 0
            ? theme.palette.mode === 'dark'
              ? '#121212' // a darker shade for even rows in dark mode
              : '#F0EFF8'
            : 'inherit',
      },
    }),
  };
  const tableInstance = useMaterialReactTable(tableOptions);
  useEffect(() => {
    setUserEmailValid(validateEmail(email));
  }, [email]);
  useEffect(() => {
    if (alertsEmailData) {
      if (alertsEmailData.status === 200) {
        setAlertMessage('Email sent successfully');
        setAlertType('success');
        setAlertOpen(true);
      } else {
        setAlertMessage('Failed to send email');
        setAlertType('error');
        setAlertOpen(true);
      }
    }
  }, [alertsEmailData]);
  const handleSubmit = () => {
    if (!userEmailValid) {
      setAlertMessage('Please enter a valid email address');
      return;
    }
    console.log(
      'Sharing Footage link:',
      window.location.href,
      'with email:',
      email,
      'and video link:',
      alert?.warningType,
    );
    fetchAlertsEmailData({
      emailId: email,
      deviceId: alert?.device_id,
      warningSortKey: alert?.warningSortKey,
    });
    setEmail('');
    setOpenEmailModal(false);
  };
  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);

  const handleCustomiseModalOpen = (event: any) => {
    setIsCustomiseModalOpen(true);
  };
  const handleCustomiseModalClose = () => {
    setIsCustomiseModalOpen(false);
  };
  const handleReset = () => {
    console.log('reset clicked');
  };
  const handleFilterOpen = () => setIsFilterModelOpen(true);

  const handleFilterSave = (data: any) => {
    fetchAlertsData({
      fleetId: user?.customer_id,
      startDate: startDate,
      endDate: endDate,
      warningType: warningName,
      lastEvaluatedKey: null,
      ...(viewMode === 'grid' && { pageSize: 300 }),
      ...(data.group && { vehicleGroup: data.group }),
      ...(data.vehicle && { vehicleId: data.vehicle }),
    });
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          mb: 2, // Add some margin below the row
          mt: 4,
        }}
      >
        <button
          className="text-blue-600 font-medium flex items-center"
          onClick={() => {
            navigate(-1);
          }}
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <ArrowBack className="mr-1" /> Back
        </button>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2, // Add some margin below the row
        }}
      >
        {/* Left Section: Icon and Warning Name */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontFamily: 'Inter Tight',
              color: 'text.primary',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <img src={getWarningIcon(warningName)} alt="Warning Icon" />
            <Typography
              variant="h6"
              className={`font-semibold ${warningName === 'SOS' ? 'text-red-500' : ''}`}
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '18px',
                letterSpacing: '0%',
                textTransform: 'uppercase',
                color: warningName === 'SOS' ? 'red' : '#767676',
              }}
            >
              {warningName?.toUpperCase()}
            </Typography>
          </Typography>
          <img src={infoIcon} alt="info icon" title="More info" className="w-4 h-4 cursor-pointer" />
          {/* <Tooltip title={} arrow>
                                 <img
                                   src={info}
                                   alt="info icon"
                                   className="w-4 h-4 cursor-pointer"
                                 />
                               </Tooltip> */}
          <Chip
            label={totalRecords || 0}
            size="small"
            sx={{
              width: 54,
              height: 24,
              gap: '10px',
              borderRadius: '4px',
              backgroundColor: '#EAE9F5',
              color: 'black',
            }}
          />
          <Box
            sx={{
              width: isCritical ? 57 : 100,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: isCritical ? '10px' : '4px',
              borderRadius: '8px',
              padding: '4px 8px',
              backgroundColor: isCritical ? '#F7E1E1' : '#FFF4E1',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '21px',
                letterSpacing: '0%',
                color: isCritical ? '#C83333' : '#A9861E',
              }}
            >
              {isCritical ? 'Critical' : 'Non Critical'}
            </Typography>
          </Box>
        </Box>

        {/* Right Section: Tabs and Calendar Button */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Tabs */}
          {viewMode === 'table' && (
            <CustomIconButton
              icon={<img src={Custom} alt="Custom" width={16} height={16} />}
              text="Customize"
              background="transparent"
              outline={false}
              onClick={handleCustomiseModalOpen}
            />
          )}
          <Tabs
            value={viewMode}
            onChange={(e, newVal) => setViewMode(newVal)}
            sx={{
              borderRadius: '8px',
              padding: '4px',
              backgroundColor: theme.palette.selected,
            }}
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab
              label=""
              value="grid"
              icon={<GridView />}
              iconPosition="start"
              sx={{
                ...(viewMode === 'grid'
                  ? {
                      backgroundColor: theme.palette.background.default,
                      color: theme.palette.primary.main,
                      borderRadius: '8px',
                      fontWeight: 600,
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }
                  : { color: theme.palette.text.primary }),
              }}
            />
            <Tab
              label=""
              value="table"
              icon={<TableView />}
              iconPosition="start"
              sx={{
                ...(viewMode === 'table'
                  ? {
                      backgroundColor: theme.palette.background.default,
                      color: theme.palette.primary.main,
                      borderRadius: '8px',
                      fontWeight: 600,
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }
                  : { color: theme.palette.text.primary }),
              }}
            />
          </Tabs>
          <div className="max-w-[400px]">
            <TextField
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search"
              sx={(theme) => ({
                '& .MuiOutlinedInput-root': {
                  borderColor: theme.palette.action.selected,
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%', // Ensure it takes full available height
                },
                '& .MuiInputBase-root': {
                  padding: '0rem 1rem',
                },
                '& .MuiOutlinedInput-input': {
                  padding: '0px 12px', // Adjust padding for better spacing
                  height: '48px',
                  display: 'flex',
                  alignItems: 'center',
                },
              })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="icon" width={16} height={16} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={(theme) => ({
                      height: '48px', // Ensure full height
                      maxHeight: '48px',
                      display: 'flex',
                      cursor: 'pointer',
                      alignItems: 'center',
                      borderLeft: `1px solid ${theme.palette.action.selected}`,
                      paddingLeft: '8px',
                    })}
                  >
                    <img src={filterIcon} onClick={handleFilterOpen} alt="icon" width={24} height={24} />
                  </InputAdornment>
                ),
              }}
              inputProps={{
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '14px', // You can adjust this as per Typography variant
                  fontWeight: 500, // Normal text weight
                },
              }}
            />
          </div>
        </Box>
      </Box>
      <Box>
        {Object.entries(groupAlertsByDate(filteredData)).map(([date, dateAlerts]) => (
          <Box>
            {viewMode === 'grid' && (
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontFamily: 'Inter Tight',
                  color: 'text.secondary',
                  mb: 2,
                  pl: 2,
                  mt: 2,
                }}
              >
                {`${date} (${(dateAlerts as Alert[]).length})`}
              </Typography>
            )}
            {viewMode === 'grid' && (
              <Box className="grid grid-cols-4 gap-3">
                {(dateAlerts as Alert[])?.map((alert) => (
                  <Card
                    key={alert.id}
                    sx={{
                      maxWidth: 375.5,
                      height: 81,
                      borderRadius: '12px',
                      border: '1px solid #F0EFF8',
                      boxShadow: 'none',
                      '&:hover': { boxShadow: 3 },
                    }}
                    className="transition-shadow"
                  >
                    <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          width: '100%',
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                            {alert.vehicleName || 'NA'}
                          </Typography>
                          <img
                            src={comment}
                            alt="comment"
                            style={{ width: 20, height: 20, cursor: 'pointer' }}
                            onClick={() => handleCommentModalOpen(alert)}
                          />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton
                            size="small"
                            sx={{ color: '#5547DD', p: 0 }}
                            onClick={() => handleOpenLiveFeed(alert.vehicleId, alert.videoUrls)}
                          >
                            <PlayArrow fontSize="medium" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={(event) => handleOpenMenu(event, alert)}
                            sx={{ p: 0 }}
                          >
                            <MoreVert fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                          {alert.vehicleId}
                        </Typography>
                        <Typography variant="caption" sx={dateTimeStyles}>
                          {formatTimestamp(alert?.date_time)}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            )}
            <Menu anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={handleCloseMenu}>
              {viewMenuData.map((item, index) => (
                <MenuItem key={index} onClick={item.click}>
                  <div className="flex gap-2 mt-1">
                    <img src={item.icon} alt={item.name} style={{ marginRight: 8, width: 20, height: 20 }} />
                    <Typography variant="body2" fontWeight={600}>
                      {item.name}
                    </Typography>
                  </div>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        ))}
        {viewMode === 'table' && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: '100%',
              height: '100%',
            }}
          >
            {/* Table */}
            <Box
              sx={{
                flex: 1,
                overflow: 'auto',
                border: '1px solid #F0EFF8',
                borderRadius: '12px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
              }}
            >
              <MaterialReactTable table={tableInstance} />
            </Box>

            {/* Pagination */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
              }}
            >
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                shape="rounded"
                color="primary"
                siblingCount={0}
                boundaryCount={0}
                renderItem={(item) => {
                  if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                    return null;
                  }
                  return <PaginationItem {...item} />;
                }}
              />
            </Box>
          </Box>
        )}
      </Box>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="add-comment-modal"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            width: 560,
            height: 472,
            p: 4,
            borderRadius: '16px',
            border: '1px solid #F0EFF8',
            backgroundColor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          {/* Header */}
          <Typography
            variant="h5"
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 600,
              fontSize: '24px',
              lineHeight: '36px',
            }}
          >
            Add Comment
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '24px',
              color: 'text.secondary',
            }}
          >
            Provide additional context or recommendations for this alert. Your comments will be logged for
            future reference and analysis.
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 'bold',
                fontSize: '16px',
                lineHeight: '24px',
                color: 'text.primary',
              }}
            >
              Comments
            </Typography>
            <TextField
              label="Write here"
              multiline
              rows={4}
              value={alertComment}
              onChange={(e) => setAlertComment(e.target.value)}
              variant="outlined"
              fullWidth
              InputLabelProps={{
                sx: {
                  fontFamily: 'Inter Tight',
                  fontWeight: 400,
                },
              }}
              InputProps={{
                sx: {
                  fontFamily: 'Inter Tight',
                  fontWeight: 400,
                },
              }}
            />
          </Box>

          {/* Buttons */}
          <Box sx={{ display: 'flex', gap: 2, mt: 'auto' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 500,
                textTransform: 'none',
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => saveComment()}
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 500,
                textTransform: 'none',
                ml: 'auto',
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <LiveFeedModal
        type="alert"
        alertName="Alert Evidence Video1"
        selectedCamera={selected}
        trip={isLiveFeedOpen}
        cameraInfo={liveFeedCameraInfo}
        isDash={true}
        open={isLiveFeedOpen.isOpen}
        onClose={handleLiveFeedClose}
      />
      <Modal open={openEmailModal} onClose={handleEmailClose}>
        <Box
          sx={{
            position: 'absolute' as const,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: 500 },
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Typography variant="h6">{heading}</Typography>
            <CustomIconButton
              text={`Copy Link`}
              icon={<img src={link} alt="link" width={24} height={24} />}
              background="transparent"
              outline={false}
              padding="0px"
              size={16}
              variant="outlined"
              onClick={() => {
                navigator.clipboard
                  .writeText(window.location.href)
                  .then(() => {
                    console.log('Link copied to clipboard!');
                  })
                  .catch((err) => {
                    console.error('Failed to copy link: ', err);
                  });
              }}
            />
          </Box>
          <Typography variant="button" fontWeight={400} className="mb-1" color="secondary">
            {subheading}
          </Typography>
          <div className="mt-4">
            <InputField
              label="Email Address"
              name="email"
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
              placeholder="Enter email address"
              status={email.length === 0 ? undefined : userEmailValid ? 'success' : 'error'}
              isDisabled={false}
            />
          </div>
          <div className="flex w-full mt-8 justify-between">
            <CustomIconButton
              text={`Cancel`}
              background="transparent"
              outline={true}
              padding="0px"
              size={16}
              variant="outlined"
              onClick={handleEmailClose}
            />
            <CustomIconButton
              text={`Send`}
              padding="0px"
              outline={false}
              size={16}
              isDisabled={!userEmailValid}
              variant="contained"
              onClick={handleSubmit}
            />
          </div>
        </Box>
      </Modal>
      <CustomiseTableModal
        open={isCustomiseModalOpen}
        onClose={handleCustomiseModalClose}
        onReset={handleReset}
        title="Customize Your Table"
        description="Select and arrange table columns as you prefer."
        columnObj={columnObj}
        setColumnObj={setColumnObj}
      />
      <FilterDataModel
        open={isFilterModel}
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        title="Filter"
        description="Use the options below to refine your search and find specific trips quickly."
        showTripStatus={false}
        trgtcData={true}
      />
      <Dialog
        open={driverDialogOpen}
        onClose={driverDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert Message</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Driver not associated with this particular alert
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={driverDialogClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TripAllAlerts;
